import { render, staticRenderFns } from "./DeviceHistory.vue?vue&type=template&id=f045d5c2&scoped=true&"
import script from "./DeviceHistory.vue?vue&type=script&lang=js&"
export * from "./DeviceHistory.vue?vue&type=script&lang=js&"
import style0 from "./DeviceHistory.vue?vue&type=style&index=0&id=f045d5c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f045d5c2",
  null
  
)

export default component.exports